module.exports = __webpack_public_path__ + "img/manuale780x680.4a746b32.png";